<template>
  <div class="news-content-container">
    <back-open-chenter />
    <div class="news-content-panel">
      <div class="news-title">斩获2022数博会领先科技成果奖，腾讯优图人脸安全能力再获权威认证</div>
      <div class="news-date">2022年5月26日</div>
      <div class="news-content">
        <div class="image-panel">
          <img class="news-image" src="../img/detail/Information/news17/news17_17.gif"/>
        </div>
        <div>
          <p>
            <strong>5月26日，2022中国国际大数据产业博览会（以下简称“数博会”）在线上举办。</strong>
            <span>其中，“数博发布之领先科技成果”奖于数博会开幕当天正式揭晓，经过激烈角逐和层层选拔，最终共55个项目从437个申报项目中脱颖而出。</span>
          </p>
        </div>
        <p>数博会由国家发展和改革委员会、工业和信息化部、国家互联网信息办公室与贵州省人民政府主办，是全球首个以大数据为主题的博览会，探讨大数据行业发展现状和趋势。凭借领先的技术积累和产品实践，腾讯在本届数博会再获佳绩，共6个项目获奖，
          <strong>其中，腾讯可信人脸安全技术获得数博会领先科技成果奖“新技术”，腾讯优图人脸安全能力再获权威认可。</strong>
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/newscenter/news13.jpg"/>
          </div>
        </div>
        <p>刷脸技术已经在生活中得到了广泛的应用，技术在带来便利的同时，也需要考虑到安全问题。腾讯可信人脸安全技术由腾讯优图实验室重点研发，着重关注人脸验证等应用中存在的安全问题，构建立体的人脸安全技术体系，全面覆盖对物理介质攻击、数字内容合成攻击和针对模型的对抗攻击的防御，为人脸信息的应用提供安全保障。</p>
        <p>
          <strong>腾讯可信人脸安全技术框架主要包括内容安全和基础安全两部分。</strong>
          内容安全部分包含多种人脸活体检测和内容取证技术，分别防御物理介质攻击和内容编辑攻击，保障人脸信息的真实性和原始性。基础安全部分包括数据安全和模型安全，保障数据存储、传播安全以及通过模型加固等手段进一步保障模型自身安全。基于内容安全和基础安全，腾讯可信人脸安全技术可以有效地防御物理介质攻击、内容合成攻击以及模型对抗攻击。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news13/news13_1.jpg"/>
          </div>
        </div>
        <p>
          <strong>腾讯可信人脸安全相关技术曾多次获得国际权威比赛冠军，</strong>
          目前已获授权发明专利50+项，申请中发明专利130+项，发表顶级会议论文20+篇；多次获得国家权威机构资质认证，如信通院-可信AI人脸识别优秀级、BCTC-活体检测算法增强级、BCTC-移动金融客户端人脸识别技术增强级等，同时作为工信部-第一期人工智能产业创新揭榜优胜单位完成揭榜任务；并获得2021 第三届中国人工智能大赛 “创新之星”，上海市科技进步奖特等奖等奖项。
        </p>
        <p>
          <strong>目前，腾讯可信人脸安全技术已经为多款腾讯产品提供人脸安全能力支撑，基于可信人脸安全技术，已提出人脸核身、刷脸支付、人脸防伪等多项解决方案。</strong>
          同时，通过腾讯云慧眼、微信开放平台等平台，为行业提供人脸安全服务，可广泛应用在金融服务、生活出行等需要验证用户身份的场景中，支持远程认证和自助办理。疫情期间，腾讯可信人脸安全技术支持了多个城市健康码，基于光线活体等人脸安全技术，安全有效地解决用户远程实名制身份验证的难题，助力健康安全出行。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news13/news13_2.jpg"/>
          </div>
        </div>
        <p>如今，人脸应用安全是智能时代的重要命题，为防范AI技术滥用，未来，腾讯优图将在人脸安全领域持续深耕，精心打磨算法研究和业务落地，同时开放和输出相关技术服务，更好地保障相关应用的安全，同时坚持科技向善理念，推进可持续社会价值创新，让AI更好地为社会服务。</p>
      </div>
    </div>
  </div>
</template>

<script>
import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
export default {
  name: 'News13',
  components: {
    BackOpenChenter
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content-container {
  .news-content-panel .news-content{
    .image-panel {
      .news-image {
        width: 605px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News13.vue